import { createFileRoute } from '@tanstack/react-router';
import { LessonPage } from '@/features/lessons/LessonPage';

export const Route = createFileRoute('/lessons/$slug')({
  component: LessonRoute,
});

function LessonRoute() {
  const { slug } = Route.useParams();
  return <LessonPage slug={slug} />;
}
